import apiClient from './client';
// Note: This API assumes the backend acts as a proxy to GitHub API
// to avoid exposing GitHub tokens on the client side
export const githubApi = {
    /**
     * Get all issues across organization repositories
     */
    async getIssues(filters = {}) {
        const params = new URLSearchParams();
        if (filters.state)
            params.append('state', filters.state);
        if (filters.repository)
            params.append('repository', filters.repository);
        if (filters.labels && filters.labels.length > 0) {
            params.append('labels', filters.labels.join(','));
        }
        if (filters.assignee)
            params.append('assignee', filters.assignee);
        if (filters.milestone)
            params.append('milestone', filters.milestone);
        if (filters.search)
            params.append('search', filters.search);
        if (filters.sort)
            params.append('sort', filters.sort);
        if (filters.direction)
            params.append('direction', filters.direction);
        if (filters.page)
            params.append('page', filters.page.toString());
        if (filters.perPage)
            params.append('perPage', filters.perPage.toString());
        const response = await apiClient.get(`/v1/admin/github/issues?${params.toString()}`);
        return response.data;
    },
    /**
     * Get a single issue by repository and issue number
     */
    async getIssue(owner, repo, issueNumber) {
        const response = await apiClient.get(`/v1/admin/github/repos/${owner}/${repo}/issues/${issueNumber}`);
        return response.data;
    },
    /**
     * Get comments for an issue
     */
    async getIssueComments(owner, repo, issueNumber) {
        const response = await apiClient.get(`/v1/admin/github/repos/${owner}/${repo}/issues/${issueNumber}/comments`);
        return response.data;
    },
    /**
     * Update an issue (state, labels, assignees, milestone)
     */
    async updateIssue(owner, repo, issueNumber, data) {
        const response = await apiClient.patch(`/v1/admin/github/repos/${owner}/${repo}/issues/${issueNumber}`, data);
        return response.data;
    },
    /**
     * Get all repositories in the organization
     */
    async getRepositories() {
        const response = await apiClient.get('/v1/admin/github/repos');
        return response.data;
    },
    /**
     * Get available labels in a repository
     */
    async getLabels(owner, repo) {
        const response = await apiClient.get(`/v1/admin/github/repos/${owner}/${repo}/labels`);
        return response.data;
    },
    /**
     * Get organization members (for assignee filter)
     */
    async getOrgMembers() {
        const response = await apiClient.get('/v1/admin/github/members');
        return response.data;
    },
    /**
     * Get issue metrics and statistics
     */
    async getIssueMetrics() {
        const response = await apiClient.get('/v1/admin/github/issues/metrics');
        return response.data;
    },
    /**
     * Assign users to an issue
     */
    async addAssignees(owner, repo, issueNumber, assignees) {
        const response = await apiClient.post(`/v1/admin/github/repos/${owner}/${repo}/issues/${issueNumber}/assignees`, { assignees });
        return response.data;
    },
    /**
     * Remove assignees from an issue
     */
    async removeAssignees(owner, repo, issueNumber, assignees) {
        const response = await apiClient.delete(`/v1/admin/github/repos/${owner}/${repo}/issues/${issueNumber}/assignees`, { data: { assignees } });
        return response.data;
    },
    /**
     * Add labels to an issue
     */
    async addLabels(owner, repo, issueNumber, labels) {
        const response = await apiClient.post(`/v1/admin/github/repos/${owner}/${repo}/issues/${issueNumber}/labels`, { labels });
        return response.data;
    },
    /**
     * Remove a label from an issue
     */
    async removeLabel(owner, repo, issueNumber, label) {
        await apiClient.delete(`/v1/admin/github/repos/${owner}/${repo}/issues/${issueNumber}/labels/${label}`);
    },
};
